export const frequencySelectData = [
  { id: "1", value: "One Time" },
  { id: "2", value: "Daily" },
  { id: "3", value: "Weekly" },
  { id: "4", value: "Monthly" },
];